import { IconCaretDown } from '@tabler/icons-react'
import styled, { css } from 'styled-components'

import { Button, ButtonProps } from '../BUI/Button'

import { buildPassTheme } from 'src/styles/theme'

type CustomButtonProps = {
  hasValue: boolean
}

const CustomButton = styled(Button)<CustomButtonProps>`
  background-color: transparent;
  color: ${({ theme }) => theme.colour.secondary._400};

  &:hover {
    background-color: ${({ theme }) => theme.colour.secondary._50};
  }

  ${({ hasValue }) =>
    hasValue &&
    css`
      color: ${({ theme }) => theme.colour.secondary.base};
    `}
`

type Props = ButtonProps & CustomButtonProps

export const FilterButton: React.FC<Props> = ({
  hasValue,
  children,
  ...props
}) => {
  return (
    <CustomButton variant="secondary" hasValue={hasValue} {...props}>
      {children}
      <IconCaretDown
        color={buildPassTheme.colour.secondary.base}
        fill={buildPassTheme.colour.secondary.base}
        size={16}
      />
    </CustomButton>
  )
}
